module.exports = __webpack_public_path__ + "static/media/Rocket_Academ.80471ebf.png";